import { CircularProgress, IconButton } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import { useDownloadPdfExitStatement } from 'hooks/data/investorReporting/useDownloadPdfExitStatement';

type Props = {
  exitStatementId: string;
  investorId: string;
  filename: string;
  pdfUrl: string;
  includePreviousExitStatements?: boolean;
};

const DownloadPdfExitStatementButton: React.FC<Props> = ({
  exitStatementId,
  investorId,
  filename,
  pdfUrl,
  includePreviousExitStatements = false,
}) => {
  const { loading, download } = useDownloadPdfExitStatement({
    exitStatementId,
    investorId,
    filename,
    pdfUrl,
    includePreviousExitStatements,
  });

  return (
    <IconButton onClick={download} disabled={loading} size="large">
      {loading ? <CircularProgress size={24} /> : <CloudDownload />}
    </IconButton>
  );
};

export default DownloadPdfExitStatementButton;
